import React, { FC, useEffect, useMemo } from 'react';

import { Box, Stack, Typography } from '@mui/material';

import {
  adminActions,
  adminPharmacistPictures,
} from '@pharmaplan/common';
import type { IAdminBookedProfessional } from '@pharmaplan/common';

import { ReactComponent as WarningIcon } from '../../assets/svg/warningIcon.svg';
import useCancelMultipleBooking from '../../hooks/useCancelMultipleBooking';
import CustomAvatarSection from '../common/CustomAvatarSection';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import useGetItems from '../../hooks/useGetItems';
import strings from '../../localization';

import styles from './styles';

interface IUserSelectionModal {
  longTermShiftContractId?: string;
  bookedProfessionals?: Array<IAdminBookedProfessional>;
}

const UserSelectionModal: FC<IUserSelectionModal> = ({
  bookedProfessionals = [],
  longTermShiftContractId = '',
}) => {
  const dispatch = useAppDispatch();
  const { getPharmacistImage } = useGetItems();
  const { showCancellationDialog } = useCancelMultipleBooking();

  const pIds = useMemo(
    () =>
      bookedProfessionals?.map((item) =>
        item.professionalId ?? ''),
    [bookedProfessionals],
  );

  useEffect(() => {
    dispatch(adminPharmacistPictures(pIds));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pIds]);

  return (
    <Stack sx={styles.container}>
      <Box sx={styles.iconContainer}>
        <WarningIcon />
        <Typography sx={styles.title}>{strings.requestCancellation}</Typography>
        <Typography sx={styles.message}>
          {strings.pleaseChooseReplacementToCancel}
        </Typography>
      </Box>
      {bookedProfessionals?.map((item) => {
        const { professionalId, professionalName } = item ?? {};
        return (
          <Box sx={{ my: 0.5 }} key={professionalId}>
            <CustomAvatarSection
              onClick={() =>
                showCancellationDialog({
                  professionalId,
                  longTermShiftContractId,
                })}
              customContainerStyle={styles.customContainer}
              customTitleStyle={{ mt: 3 }}
              title={professionalName}
              avatar={getPharmacistImage(professionalId)}
              imageSuccessAction={adminActions.adminPharmacistPictures}
              config={[]}
              menuActions={null}
              successAction={adminActions.getPharmacyWorkshiftsList}
            />
          </Box>
        );
      })}
    </Stack>
  );
};

export default UserSelectionModal;
